module.exports = __webpack_public_path__ + "static/media/shipping-import.20b1b7c4.svg";